export const maxCreditCardSurchargePercentageFee = 4;
export const maxAchSurchargePercentageFee = 1;
export const maxCreditCardFlatFee = 10;
export const maxAchFlatFee = 10;
export const maxInteracFlatFee = 1;
